import { render, staticRenderFns } from "./ProductReviewSummary.vue?vue&type=template&id=35240419&"
import script from "./ProductReviewSummary.vue?vue&type=script&lang=js&"
export * from "./ProductReviewSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports